import { AutomationModeEnum, AutomationTypeEnum } from '@/store/modules/automation/types'
import { CountryEnum, ModeEnum, StayListColumns } from '@/store/modules/settings/types'

/**
 * Column names must be synced with backend/src/Resources/schemas/user_settings.json
 */
const AvailableColumns: StayListColumns = {
  notification: {
    icon: 'bell-fill',
    name: 'Notification',
    label: 'Notification',
    country: [CountryEnum.CH, CountryEnum.FR],
    order: 'notification',
    mode: [ModeEnum.AUTOMATION, AutomationModeEnum.AUTOMATABLE, AutomationModeEnum.WAITING, AutomationModeEnum.EXPIRED, ModeEnum.NEW_CODING, ModeEnum.OPTIMIZABLE, ModeEnum.QUALITY_STAYS, ModeEnum.DIALYSIS],
    automationType: [AutomationTypeEnum.AI, AutomationTypeEnum.RULES],
    isDefault: true,
    invertedOrder: false,
    columnGroup: 'sancareState',
  },
  rssId: {
    isTranslated: true,
    label: 'stay.RSS',
    country: [CountryEnum.CH, CountryEnum.FR],
    order: 'rssId',
    mode: [ModeEnum.AUTOMATION, AutomationModeEnum.AUTOMATABLE, AutomationModeEnum.WAITING, AutomationModeEnum.EXPIRED, ModeEnum.NEW_CODING, ModeEnum.OPTIMIZABLE, ModeEnum.QUALITY_STAYS, ModeEnum.DIALYSIS],
    automationType: [AutomationTypeEnum.AI, AutomationTypeEnum.RULES],
    isDefault: false,
    invertedOrder: false,
    columnGroup: 'administrativeInfo',
  },
  administrativeLocalStayId: {
    label: 'N° administratif',
    country: [CountryEnum.CH, CountryEnum.FR],
    order: 'administrativeLocalStayId',
    mode: [ModeEnum.AUTOMATION, AutomationModeEnum.AUTOMATABLE, AutomationModeEnum.WAITING, AutomationModeEnum.EXPIRED, ModeEnum.NEW_CODING, ModeEnum.OPTIMIZABLE, ModeEnum.QUALITY_STAYS, ModeEnum.DIALYSIS],
    automationType: [AutomationTypeEnum.AI, AutomationTypeEnum.RULES],
    isDefault: true,
    invertedOrder: false,
    columnGroup: 'administrativeInfo',
  },
  patientName: {
    name: 'Patient',
    label: 'Nom - Prénom',
    country: [CountryEnum.FR],
    order: 'patientName',
    mode: [ModeEnum.AUTOMATION, AutomationModeEnum.AUTOMATABLE, AutomationModeEnum.WAITING, AutomationModeEnum.EXPIRED, ModeEnum.NEW_CODING, ModeEnum.OPTIMIZABLE, ModeEnum.QUALITY_STAYS, ModeEnum.DIALYSIS],
    automationType: [AutomationTypeEnum.AI, AutomationTypeEnum.RULES],
    isDefault: true,
    invertedOrder: false,
    columnGroup: 'administrativeInfo',
  },
  firstGhm: {
    label: 'GHM pré-revalo.',
    country: [CountryEnum.FR],
    order: 'startingGhm',
    mode: [ModeEnum.OPTIMIZABLE, ModeEnum.QUALITY_STAYS, ModeEnum.DIALYSIS],
    automationType: [],
    isDefault: false,
    invertedOrder: false,
    columnGroup: 'initialGrouping',
  },
  currentGhm: {
    label: 'GHM',
    country: [CountryEnum.FR],
    order: 'currentGhm',
    mode: [ModeEnum.AUTOMATION, AutomationModeEnum.AUTOMATABLE, AutomationModeEnum.WAITING, AutomationModeEnum.EXPIRED, ModeEnum.NEW_CODING, ModeEnum.OPTIMIZABLE, ModeEnum.QUALITY_STAYS, ModeEnum.DIALYSIS],
    automationType: [AutomationTypeEnum.AI, AutomationTypeEnum.RULES],
    isDefault: true,
    invertedOrder: false,
    columnGroup: 'currentGrouping',
  },
  firstDrg: {
    label: 'DRG pré-revalo.',
    country: [CountryEnum.CH],
    order: 'firstDrg',
    mode: [ModeEnum.OPTIMIZABLE, ModeEnum.QUALITY_STAYS],
    automationType: [],
    isDefault: true,
    invertedOrder: false,
    columnGroup: 'initialGrouping',
  },
  currentDrg: {
    label: 'DRG',
    country: [CountryEnum.CH],
    order: 'currentDrg',
    mode: [ModeEnum.AUTOMATION, AutomationModeEnum.AUTOMATABLE, AutomationModeEnum.WAITING, AutomationModeEnum.EXPIRED, ModeEnum.NEW_CODING, ModeEnum.OPTIMIZABLE, ModeEnum.QUALITY_STAYS],
    automationType: [AutomationTypeEnum.AI, AutomationTypeEnum.RULES],
    isDefault: true,
    invertedOrder: false,
    columnGroup: 'currentGrouping',
  },
  firstGhmLevel: {
    label: 'Niv. GHM pré-revalo.',
    country: [CountryEnum.FR],
    order: 'startingGhmLevel',
    mode: [ModeEnum.OPTIMIZABLE, ModeEnum.QUALITY_STAYS, ModeEnum.DIALYSIS],
    automationType: [],
    isDefault: false,
    invertedOrder: false,
    columnGroup: 'initialGrouping',
  },
  currentGhmLevel: {
    label: 'Niv. GHM',
    country: [CountryEnum.FR],
    order: 'currentGhmLevel',
    mode: [ModeEnum.AUTOMATION, AutomationModeEnum.AUTOMATABLE, AutomationModeEnum.WAITING, AutomationModeEnum.EXPIRED, ModeEnum.NEW_CODING, ModeEnum.OPTIMIZABLE, ModeEnum.QUALITY_STAYS, ModeEnum.DIALYSIS],
    automationType: [AutomationTypeEnum.AI, AutomationTypeEnum.RULES],
    isDefault: false,
    invertedOrder: true,
    columnGroup: 'currentGrouping',
  },
  firstValue: {
    isTranslated: true,
    label: 'stayList.labels.firstValue',
    country: [CountryEnum.CH, CountryEnum.FR],
    order: 'startingValue',
    mode: [ModeEnum.OPTIMIZABLE, ModeEnum.QUALITY_STAYS, ModeEnum.DIALYSIS],
    automationType: [],
    isDefault: false,
    invertedOrder: true,
    columnGroup: 'initialGrouping',
  },
  currentValue: {
    isTranslated: true,
    label: 'stayList.labels.currentValue',
    country: [CountryEnum.CH, CountryEnum.FR],
    order: 'currentValue',
    mode: [ModeEnum.AUTOMATION, AutomationModeEnum.AUTOMATABLE, AutomationModeEnum.WAITING, AutomationModeEnum.EXPIRED, ModeEnum.NEW_CODING, ModeEnum.OPTIMIZABLE, ModeEnum.QUALITY_STAYS, ModeEnum.DIALYSIS],
    automationType: [AutomationTypeEnum.AI, AutomationTypeEnum.RULES],
    isDefault: false,
    invertedOrder: true,
    columnGroup: 'currentGrouping',
  },
  moneyGap: {
    label: 'Montant revalorisé',
    country: [CountryEnum.FR],
    order: 'moneyGap',
    mode: [ModeEnum.OPTIMIZABLE, ModeEnum.QUALITY_STAYS, ModeEnum.DIALYSIS],
    automationType: [],
    isDefault: false,
    invertedOrder: true,
    columnGroup: 'currentGrouping',
  },
  rumCount: {
    label: 'Nombre de RUM',
    country: [CountryEnum.FR],
    order: 'rumCount',
    mode: [ModeEnum.AUTOMATION, AutomationModeEnum.AUTOMATABLE, AutomationModeEnum.WAITING, AutomationModeEnum.EXPIRED, ModeEnum.NEW_CODING, ModeEnum.OPTIMIZABLE, ModeEnum.QUALITY_STAYS, ModeEnum.DIALYSIS],
    automationType: [AutomationTypeEnum.AI, AutomationTypeEnum.RULES],
    isDefault: true,
    invertedOrder: true,
    columnGroup: 'administrativeInfo',
  },
  stayStart: {
    label: 'Date d\'entrée',
    country: [CountryEnum.CH, CountryEnum.FR],
    order: 'stayStart',
    mode: [ModeEnum.AUTOMATION, AutomationModeEnum.AUTOMATABLE, AutomationModeEnum.WAITING, AutomationModeEnum.EXPIRED, ModeEnum.NEW_CODING, ModeEnum.OPTIMIZABLE, ModeEnum.QUALITY_STAYS, ModeEnum.DIALYSIS],
    automationType: [AutomationTypeEnum.AI, AutomationTypeEnum.RULES],
    isDefault: false,
    invertedOrder: false,
    columnGroup: 'administrativeInfo',
  },
  stayEnd: {
    label: 'Date de sortie',
    country: [CountryEnum.CH, CountryEnum.FR],
    order: 'stayEnd',
    mode: [ModeEnum.AUTOMATION, AutomationModeEnum.AUTOMATABLE, AutomationModeEnum.WAITING, AutomationModeEnum.EXPIRED, ModeEnum.NEW_CODING, ModeEnum.OPTIMIZABLE, ModeEnum.QUALITY_STAYS, ModeEnum.DIALYSIS],
    automationType: [AutomationTypeEnum.AI, AutomationTypeEnum.RULES],
    isDefault: false,
    invertedOrder: false,
    columnGroup: 'administrativeInfo',
  },
  validationDate: {
    label: 'Date de validation',
    country: [CountryEnum.CH, CountryEnum.FR],
    order: 'validationDate',
    mode: [ModeEnum.AUTOMATION, AutomationModeEnum.AUTOMATABLE, AutomationModeEnum.WAITING, AutomationModeEnum.EXPIRED, ModeEnum.NEW_CODING, ModeEnum.OPTIMIZABLE, ModeEnum.QUALITY_STAYS, ModeEnum.DIALYSIS],
    automationType: [AutomationTypeEnum.AI, AutomationTypeEnum.RULES],
    isDefault: false,
    invertedOrder: false,
    columnGroup: 'sancareState',
  },
  stayDuration: {
    label: 'Durée de séjour',
    country: [CountryEnum.CH, CountryEnum.FR],
    order: 'stayDuration',
    mode: [ModeEnum.AUTOMATION, AutomationModeEnum.AUTOMATABLE, AutomationModeEnum.WAITING, AutomationModeEnum.EXPIRED, ModeEnum.NEW_CODING, ModeEnum.OPTIMIZABLE, ModeEnum.QUALITY_STAYS, ModeEnum.DIALYSIS],
    automationType: [AutomationTypeEnum.AI, AutomationTypeEnum.RULES],
    isDefault: true,
    invertedOrder: true,
    columnGroup: 'administrativeInfo',
  },
  confidence: {
    label: 'Confiance',
    country: [CountryEnum.FR],
    order: 'confidence',
    mode: [ModeEnum.AUTOMATION, AutomationModeEnum.AUTOMATABLE, AutomationModeEnum.WAITING, AutomationModeEnum.EXPIRED],
    automationType: [AutomationTypeEnum.AI],
    isDefault: false,
    invertedOrder: true,
    columnGroup: 'sancareCodingAssistance',
  },
  dpConfidence: {
    label: 'Confiance DP',
    country: [CountryEnum.FR],
    order: 'dpConfidence',
    mode: [ModeEnum.NEW_CODING, ModeEnum.OPTIMIZABLE, ModeEnum.QUALITY_STAYS],
    automationType: [],
    isDefault: false,
    invertedOrder: true,
    columnGroup: 'sancareCodingAssistance',
  },
  countSavedSearches: {
    label: 'Nombre de recherches',
    country: [CountryEnum.CH, CountryEnum.FR],
    order: null,
    mode: [ModeEnum.NEW_CODING, ModeEnum.OPTIMIZABLE, ModeEnum.QUALITY_STAYS, ModeEnum.DIALYSIS],
    automationType: [],
    isDefault: false,
    invertedOrder: true,
    columnGroup: 'sancareCodingAssistance',
  },
  savedSearches: {
    label: 'Recherches',
    country: [CountryEnum.CH, CountryEnum.FR],
    order: null,
    mode: [ModeEnum.NEW_CODING, ModeEnum.OPTIMIZABLE, ModeEnum.QUALITY_STAYS, ModeEnum.DIALYSIS],
    automationType: [],
    isDefault: false,
    invertedOrder: false,
    columnGroup: 'sancareCodingAssistance',
  },
  status: {
    label: 'Statut',
    country: [CountryEnum.CH, CountryEnum.FR],
    order: 'status',
    mode: [ModeEnum.AUTOMATION, AutomationModeEnum.AUTOMATABLE, AutomationModeEnum.WAITING, AutomationModeEnum.EXPIRED, ModeEnum.NEW_CODING, ModeEnum.OPTIMIZABLE, ModeEnum.QUALITY_STAYS, ModeEnum.DIALYSIS],
    automationType: [AutomationTypeEnum.AI, AutomationTypeEnum.RULES],
    isDefault: true,
    invertedOrder: false,
    columnGroup: 'sancareState',
  },
  seen: {
    label: 'Vu',
    country: [CountryEnum.CH, CountryEnum.FR],
    order: 'seen',
    mode: [ModeEnum.AUTOMATION, AutomationModeEnum.AUTOMATABLE, AutomationModeEnum.WAITING, AutomationModeEnum.EXPIRED, ModeEnum.NEW_CODING, ModeEnum.OPTIMIZABLE, ModeEnum.QUALITY_STAYS, ModeEnum.DIALYSIS],
    automationType: [AutomationTypeEnum.AI, AutomationTypeEnum.RULES],
    isDefault: true,
    invertedOrder: false,
    columnGroup: 'sancareState',
  },
  supervisingMajorDoctor: {
    label: 'Médecin responsable',
    country: [CountryEnum.FR],
    order: 'supervisingMajorDoctor',
    mode: [ModeEnum.AUTOMATION, AutomationModeEnum.AUTOMATABLE, AutomationModeEnum.WAITING, AutomationModeEnum.EXPIRED, ModeEnum.NEW_CODING, ModeEnum.OPTIMIZABLE, ModeEnum.QUALITY_STAYS, ModeEnum.DIALYSIS],
    automationType: [AutomationTypeEnum.AI, AutomationTypeEnum.RULES],
    isDefault: false,
    invertedOrder: false,
    columnGroup: 'administrativeInfo',
  },
  practitionerName: {
    label: 'Médecin opérateur (acte)',
    country: [CountryEnum.FR],
    order: 'practitionerName',
    mode: [ModeEnum.AUTOMATION, AutomationModeEnum.AUTOMATABLE, AutomationModeEnum.WAITING, AutomationModeEnum.EXPIRED, ModeEnum.NEW_CODING, ModeEnum.OPTIMIZABLE, ModeEnum.QUALITY_STAYS, ModeEnum.DIALYSIS],
    automationType: [AutomationTypeEnum.AI, AutomationTypeEnum.RULES],
    isDefault: false,
    invertedOrder: false,
    columnGroup: 'administrativeInfo',
  },
  comment: {
    label: 'Commentaire',
    country: [CountryEnum.CH, CountryEnum.FR],
    order: 'comment',
    mode: [ModeEnum.AUTOMATION, AutomationModeEnum.AUTOMATABLE, AutomationModeEnum.WAITING, AutomationModeEnum.EXPIRED, ModeEnum.NEW_CODING, ModeEnum.OPTIMIZABLE, ModeEnum.QUALITY_STAYS, ModeEnum.DIALYSIS],
    automationType: [AutomationTypeEnum.AI, AutomationTypeEnum.RULES],
    isDefault: false,
    invertedOrder: false,
    columnGroup: 'sancareState',
  },
  groupingError: {
    label: 'Libellé des codes erreur de groupage',
    country: [CountryEnum.FR, CountryEnum.CH],
    order: 'groupingError',
    mode: [ModeEnum.NEW_CODING, ModeEnum.OPTIMIZABLE, ModeEnum.QUALITY_STAYS, ModeEnum.DIALYSIS],
    automationType: [],
    isDefault: false,
    invertedOrder: false,
    columnGroup: 'currentGrouping',
  },
  hasSancareNewCoding: {
    label: 'Primo-codé',
    country: [CountryEnum.FR],
    order: null,
    mode: [ModeEnum.NEW_CODING, ModeEnum.QUALITY_STAYS, ModeEnum.DIALYSIS],
    automationType: [],
    isDefault: true,
    invertedOrder: false,
    columnGroup: 'sancareState',
  },
}

export default AvailableColumns
